import { useSelector } from 'react-redux';

import { AppState } from '../app';
import { isLoginCredentials } from '../app/state/app-initialization';
import { AppURLSearchParams, AuthData, AuthState, hasJWTTokenParam, hasLegacyTokenParam } from './auth.types';
import { ParamsDictionary } from '@hooks';
import { hasOwnProperty } from '@utils';

export const useSelectorAuthState = () => {
    return useSelector<AppState, AuthState>(
        state => state.auth
    );
};

export const useSelectorAuthData = () => {
    return useSelector<AppState, AuthData | null>(
        state => state.auth?.data || null
    );
};

export const useSelectorHasAuth = () => {
    return useSelector<AppState, boolean>(
        state => {
            const { data } = state.auth;

            return data !== null &&
                (
                    hasOwnProperty(data, 'jwtToken') &&
                    typeof data.jwtToken === 'string' ||

                    hasOwnProperty(data, 'token') &&
                    typeof data.token === 'string'
                );
        }
    );
};

export function getLoginCredentialsFromParams (params: ParamsDictionary) {
    if (isLoginCredentials(params)) {
        return params;
    }

    return null;
}

export function getAuthTokensFromParams (params: ParamsDictionary): AuthData | null {
    const tokens: Record<'jwtToken' | 'token', string> = {} as any;

    if (hasJWTTokenParam(params)) {
        // The keyname is different in the backend data model and the url search params
        tokens.jwtToken = params[AppURLSearchParams.jwtToken];
    }

    if (hasLegacyTokenParam(params)) {
        tokens.token = params[AppURLSearchParams.token];
    }

    return Object.keys(tokens).length === 0 ? null : tokens;
}
